// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"b9056552","306":"1f57f104","489":"b9056552","586":"e2e66609"}[chunkId] + ".chunk.css";
};